

















import mixins from 'vue-typed-mixins';
import { Page, Survey } from '@/utils/SurveyUtils';
import LayoutUtils from './LayoutUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Page,
    },
    layout: {
      type: Array as () => Survey['layout'],
    },
  },
  methods: {
    validateMove(evt: any) {
      return LayoutUtils.validateMove(evt);
    },
    edit(item: any) {
      this.$emit('edit', item);
    },
    remove(item: any) {
      this.$emit('remove', item);
    },
  },
});
